export default angular.module('tabs', [])
    /**
     * @ngdoc service
     * @name tabs.service:TabService
     * @description
     * Abstracts the tab-related logic within a shared service
     */
    // @ngInject
    .service('TabService', function ($timeout) {
        var active_tab;
        var tabs = [];

        // Returns all available tabs
        this.getTabs = function () {
            return tabs;
        };

        // Returns true if the tab parameter is the currect active_tab
        // @param tab {*} The item representing a tab
        this.isActiveTab = function (tab) {
            return tab === active_tab;
        };

        // Sets the active_tab to the tab parameter
        // @param tab {*} The tab (or tab identifier) to be made active
        this.setActiveTab = function (tab) {
            $timeout(function () {
                active_tab = tab;
            });
        };

        // Add a tab to the list of available tabs
        // @param tab {*} A tab (or tab identifier)
        this.addTab = function (tab) {
            tabs.push(tab);
        };

        // Return true if the provided tab is the current anchor value
        // This checks for the button and the content.
        // @param tab
        this.isAnchorTab = function (tab) {
            return location.hash.slice(1).indexOf(tab) === 0;
        };
    })
    /**
     * @ngdoc controller
     * @name tabs.controller:TabsController
     * @description
     * Controls the visibility and state of tabbed content
     */
    // @ngInject
    .controller('TabsController', function ($scope, TabService) {
        $scope.getTabs = TabService.getTabs;
        $scope.isActiveTab = TabService.isActiveTab;
        $scope.setActiveTab = TabService.setActiveTab;
        $scope.addTab = TabService.addTab;
        $scope.isAnchorTab = TabService.isAnchorTab;
         // Create a complete class name by concatenating a base class with
         // an element type and a state specifier (e.g. contact-button--active)
         // @param type {string} the type of element inthe tab group (e.g. button)
         // @param specifier {string} the state of the above element (e.g. active)
        $scope.makeClassName = function (type, specifier) {
            if (specifier) {
                type = [type, specifier].join('--');
            }
            return [$scope.base_class, type].join('-');
        };
    })
    /**
     * @ngdoc directive
     * @name tabs.directive:tabs
     * @restrict E
     * @description
     * Wraps contents as tabbed content and creates a dynamic tab bar
     */
    // @ngInject
    .directive('tabs', function () {
        return {
            scope: true,
            controller: 'TabsController',
            restrict: 'A',
            compile: function ($scope, $element) {
                return {
                    pre: function ($scope, $element, attrs, controller) {
                        $scope.base_class = attrs.tabClass || 'tab-group';
                    }
                };
            }
        };
    })
    /**
     * @ngdoc directive
     * @name tabs.directive:tabButtonContainer
     * @restrict E
     * @description
     * Registers a container to add tabs buttons to
     */
    // @ngInject
    .directive('tabButtonContainer', function () {
        return {
            controller: 'TabsController',
            compile: function ($scope, $element) {
                return {
                    pre: function ($scope, $element) {
                        $scope.container = $element;
                    }
                };
            }
        };
    })
    /**
     * @ngdoc directive
     * @name tabs.directive:tabButtonRemote
     * @restrict A
     * @description
     * Add tab-switching functionality to buttons outside of the tab container
     */
    // @ngInject
    .directive('tabButtonRemote', function (TabService) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                $element.on('click', function () {
                    TabService.setActiveTab(attrs.tabButtonRemote);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name tabs.directive:tabButton
     * @restrict A
     * @description
     * Add tab-switching functionality to tab buttons
     */
    // @ngInject
    .directive('tabButton', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var active_class = $scope.makeClassName('button', 'active');

                $element.on('click', function (e) {
                    e.preventDefault();
                    $scope.setActiveTab(attrs.tabButton);
                });

                $scope.$watch(function () {
                    return $scope.isActiveTab(attrs.tabButton);
                }, function (is_active) {
                    $element.toggleClass(active_class, is_active);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name tabs.directive:tabContent
     * @restrict E
     * @description
     * Encapsulates a content block as a single tab
     */
    // @ngInject
    .directive('tab', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var active_class = $scope.makeClassName('content', 'active');
                $scope.addTab({
                    id: attrs.tab,
                    label: attrs.tabLabel,
                    icon: attrs.tabIcon || attrs.tab
                });
                if (attrs.activeTab || $scope.isAnchorTab(attrs.tab)) {
                    $scope.setActiveTab(attrs.tab);
                }
                $scope.$watch(function () {
                    return $scope.isActiveTab(attrs.tab);
                }, function (is_active) {
                    $element.toggleClass(active_class, is_active);
                });
            }
        };
    });
